import dayjs from 'dayjs';
import { FieldErrors, FieldValues, get } from 'react-hook-form';

type ErrorWithMessage = {
  response?: { data?: { message?: string } };
  message?: string;
};

export function getErrorMessage<T extends FieldValues>(
  errors: FieldErrors<T>,
  fieldName: string
): string {
  const error = get(errors, fieldName);
  if (!error) {
    return '';
  }

  if (typeof error.message === 'string') {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error.message && typeof error.message === 'object') {
    return Object.values(error.message).join(', ');
  }

  return String(error.message ?? '');
}

export const getAxiosErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (typeof error === 'object' && error !== null) {
    const maybeError = error as ErrorWithMessage;
    if (maybeError.response?.data?.message) {
      return maybeError.response.data.message;
    }
    if (maybeError.message) {
      return maybeError.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};

export const formatDate = (
  value: string | null | undefined,
  format: string
): string => {
  if (!value) {
    return '-';
  }
  const d = dayjs(value);
  return d.isValid() ? d.format(format) : '-';
};
